export const MANDATE = [
  { id: "AVAILABLE", label: "AVAILABLE" },
  { id: "TO_BE_REQUEST", label: "TO BE REQUESTED" },
];
export const REPRESENTATION = ["DIRECT", "INDIRECT"];
export const REPRESENTATION_OPTIONS = [
  { id: "DIRECT", label: "Direct" },
  { id: "INDIRECT", label: "Indirect" },
];
export const PAYMENT_METHOD = [
  { id: "CASH_PAGOPA", label: "Cash/Pagopa" },
  { id: "CASH_BY_DIFFERENT_ACCOUNT", label: "Cash by different account" },
  { id: "INTENT_DECLARATION", label: "Dichiarazione intento" },
  { id: "FISCAL_WAREHOUSE", label: "Fiscal warehouse (magazzino fiscale)" },
];
export const VAT_PAYMENT_METHOD = [
  { id: "CASH", label: "Cash" },
  { id: "INTENT_DECLARATION", label: "Dichiarazione intento" },
];
export const CUSTOMS_PROCEDURE = [
  { id: "PROCEDURE_40", label: "40" },
  { id: "PROCEDURE_45", label: "45" },
  { id: "PROCEDURE_51", label: "51" },
  { id: "PROCEDURE_71", label: "71" },
  { id: "PROCEDURE_80", label: "80" },
];

export const CUSTOMS_PROCEDURE_H1 = [
  { id: "PROCEDURE_40", label: "40" },
  { id: "PROCEDURE_45", label: "45" },
];

export const CUSTOMS_PROCEDURE_H2 = [{ id: "PROCEDURE_71", label: "71" }];

export const CUSTOMS_PROCEDURE_H4 = [{ id: "PROCEDURE_51", label: "51" }];

export const CUSTOMS_PROCEDURE_D1 = [{ id: "PROCEDURE_80", label: "80" }];

export const CUSTOM_DECLARATIONS = [
  { id: "Y069", label: "Y069" },
  { id: "Y824", label: "Y824" },
];

export const DOCUMENTS = [
  { id: "H1", label: "H1" },
  { id: "H4", label: "H4" },
  { id: "D1", label: "D1 Transit" },
  { id: "H2", label: "H2" },
  { id: "D1_INTRO", label: "D1 Intro" },
];

export const NON_PREFERENTIAL = [
  { id: "NO", label: "No" },
  { id: "CERTIFICATE_OF_ORIGIN", label: "Certificate of Origin" },
];

export const PREFERENTIAL = [
  { id: "NO", label: "No" },
  { id: "EUR_1", label: "EUR 1" },
  { id: "REX_DECLARATION", label: "REX DECLARATION" },
  { id: "ATR", label: "ATR" },
];

export const RELEASE_TYPE = [
  { id: "CA_RELEASED", label: "CA (released)" },
  {
    id: "DOCUMENTARY_CHECK",
    label: "Documentary Check",
  },
  {
    id: "CUSTOMS_INSPECTION",
    label: "Customs Inspection",
  },
  { id: "SCANNER_CHECK", label: "Scanner check" },
  { id: "SVAD_INSPECTION", label: "SVAD Inspection" },
];

export const VALUE_CHECKPOINT_NOTE = `<h3>Da mandato generale l'importatore conferma quanto segue:</h2>
<ol>
  <li>Non esistono legami fra il mandante e le società venditrici ai sensi dell'art.127 del Reg.UE 2447/2015; (in caso contrario specificare se i legami hanno o non hanno influito sul prezzo del merci oggetto dell'importazione)</li>
  <li>Non esistono restrizioni sulla cessione o sull'utilizzazione delle merci importate dal mandante</li>
  <li>Non esistono corrispettivi di licenza da pagare da parte del compratore</li>
  <li>Non Esistono costi fatturati a parte ( imballaggi / materiale / componenti / stampi / matrici / royalties )</li>
</ol>
`;

export const initialCustomsGeneral = {
  customs_broker_id: null,
  customs_representative_mandate: null,
  customs_representation: null,
  fiscal_warehouse_id: null,
  fiscal_warehouse_code: null,
  payment_method: null,
  customs_procedure: null,
  guarantee: null,
  guarantee_code: null,
  customs_authorization_bonded_area: null,
  customs_procedure_bonded: null,
  document_type: null,
  customs_warehouse_id: null,
  sanitary_practice_application: null,
  sanitary_practice_supplier_type: null,
  sanitary_practice_supplier_id: null,
  phytosanitary_authorization_application: null,
  phytosanitary_supplier_type: null,
  phytosanitary_supplier_id: null,
  customs_declaration: null,
};

export const autocompleteFieldConfig = {
  supplier: {
    field: "supplier_id",
    endpoint: "/api/suppliers/names",
  },
  execution_warehouse: {
    field: "execution_warehouse_id",
    endpoint: "/api/warehouses",
  },
};

export const CUSTOMS_CONTROL_PROTOCOL_FEATURE =
  String(process.env.CUSTOMS_CONTROL_PROTOCOL_FEATURE).toLowerCase() !==
  "false";

export const CustomsBillFilter = [
  { id: "status", label: "Customs Bill Status" },
  { id: "type", label: "Type of Document" },
  { id: "date_of_acceptance", label: "Date of Acceptance" },
  { id: "representation", label: "Customs Representation" },
  { id: "office", label: "Customs House Office" },
  { id: "vat_payment", label: "Way of payment VAT and Duty" },
  { id: "reference", label: "A93" },
  { id: "payment_expire", label: "Expire Date Payment" },
  { id: "payment_date", label: "Payment Date by Customer" },
  { id: "postponed_customs_clearance", label: "Postponed Customs Clearance" },
];

export const STATUS = [
  { id: "DRAFT", label: "DRAFT" },
  { id: "FINAL_H1", label: "FINAL H1" },
  { id: "FINAL_H2", label: "FINAL H2" },
  { id: "FINAL_H4", label: "FINAL H4" },
  { id: "FINAL_D1", label: "FINAL D1 TRANSIT" },
  { id: "FINAL_D1_INTRO", label: "FINAL D1 INTRO" },
  { id: "FINAL_A22", label: "FINAL A22" },
  { id: "FINAL_A28", label: "FINAL A28" },
  { id: "CANCELED", label: "CANCELED" },
];

export const TYPE = [
  { id: "H1", label: "H1" },
  { id: "H4", label: "H4" },
  { id: "D1", label: "D1 Transit" },
  { id: "H2", label: "H2" },
  { id: "D1_INTRO", label: "D1 Intro" },
  { id: "A22", label: "A22" },
  { id: "A28", label: "A28" },
];

export const VAT_PAYMENT = [
  { id: "CASH_PAGOPA", label: "Cash by Pagopa" },
  { id: "CASH_BY_DIFFERENT_ACCOUNT", label: "Differed account" },
];

export const BROKER = [
  { id: "SEAWAY", label: "Seaway" },
  { id: "SUPPLIER", label: "Supplier" },
];

export const SENDER_DEPOSITOR_TYPE = [
  { id: "DEPOSITOR", label: "Sender/Depositor" },
  { id: "CUSTOMS_BROKER", label: "Customs Broker" },
];

export const GUARANTEE = [
  { id: "SEAWAY", label: "Seaway" },
  { id: "CUSTOMER", label: "Customer" },
  { id: "SUPPLIER", label: "Supplier" },
];

export const DECLARATION = [
  { id: "Y069", label: "Y069" },
  { id: "Y128", label: "Y128" },
  { id: "Y824", label: "Y824" },
  { id: "Y923", label: "Y923" },
  { id: "Y113", label: "Y113" },
];

export const INSTRUCTION = [
  { id: "NO", label: "NO" },
  { id: "INSTRUCTION_00100", label: "00100(68YY)" },
];
